import { render } from "./submit.vue?vue&type=template&id=5224f35c&scoped=true"
import script from "./submit.vue?vue&type=script&lang=ts&setup=true"
export * from "./submit.vue?vue&type=script&lang=ts&setup=true"

import "./submit.vue?vue&type=style&index=0&id=5224f35c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5224f35c"
/* hot reload */
if (module.hot) {
  script.__hmrId = "5224f35c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5224f35c', script)) {
    api.reload('5224f35c', script)
  }
  
  module.hot.accept("./submit.vue?vue&type=template&id=5224f35c&scoped=true", () => {
    api.rerender('5224f35c', render)
  })

}

script.__file = "resources/ts/components/form/submit.vue"

export default script